<template>


    <div>

        <v-card-text>
         This is a test widget


            <pre>{{store}}</pre>


        </v-card-text>

    </div>



</template>


<script>


import {plingTestStore, createTestStore} from '@/store/pinia/plingTestStore'

    export default {


        name: 'testWidget.vue',
        wconf: {

            title: 'dashboard.widget.title.test',
            location: 'primary',
            position: 10,
            active: false

        },

        setup() {

            const store = createTestStore();
            return {
                // you can return the whole store instance to use it in the template
                store

            }


        },

        data() {return {}},

        methods: {


            getTitle(){

                return this.$t('dashboard.widget.title.test')

            }

        },

        computed: {},
        mounted() {

            let self = this;
            self.store.changeData('foo');


        },
        created(){}



    }



</script>